import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ServicePreset, TypedService } from '../models/ServicePresets';
import { suspensionOfServicesIds } from '../constants/configuration';
import { AccountTypes, GlobalRouteNames, QueryParams } from '../models/Common';
import { handleSuspensionAnalytics } from '../utils';

export const useSuspensionActivation = (servicePresets: ServicePreset | undefined) => {
  const history = useHistory();
  const [suspension, setSuspension] = useState<TypedService | undefined>(undefined);
  const [isSuspensionAvailable, setIsSuspensionAvailable] = useState(false);
  const [isCurrentServiceSuspension, setIsCurrentServiceSuspension] = useState<boolean | null>(null);

  useEffect(() => {
    if (servicePresets) {
      const suspensionService =
        servicePresets?.SuspendService ??
        servicePresets?.Services?.find((el) => suspensionOfServicesIds.some((suspensionId) => suspensionId === el.id));
      setSuspension(suspensionService);

      const isCurrentServiceSuspensionService =
        (servicePresets && suspensionOfServicesIds.includes(servicePresets?.CurrentService.id)) ?? false;
      setIsCurrentServiceSuspension(isCurrentServiceSuspensionService);
      const isDaily = servicePresets?.CurrentService?.Daily;

      setIsSuspensionAvailable(!!suspensionService && !isCurrentServiceSuspensionService && !isDaily);
    }
  }, [servicePresets]);

  const handleSuspensionActivate = (id: string | number, type: AccountTypes | string, currentService: string) => {
    history.push({
      pathname: GlobalRouteNames.ServiceSuspension,
      search: `?${QueryParams.AccountId}=${id}&${QueryParams.AccountType}=${type}&${QueryParams.ServiceId}=${suspension?.id}&isChangeService=true`,
    });
    handleSuspensionAnalytics(currentService);
  };

  return { isSuspensionAvailable, isCurrentServiceSuspension, handleSuspensionActivate };
};
